import { useContext } from 'react';

import { OverlayContext } from './OverlayProvider';

export function useOverlay() {
  const { toggle, overlay } = useContext(OverlayContext);
  return { toggle, overlay };
}
